import { render, staticRenderFns } from "./SingleTabFieldsSection.vue?vue&type=template&id=454adc4c&"
import script from "./SingleTabFieldsSection.vue?vue&type=script&lang=js&"
export * from "./SingleTabFieldsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports